import React, { useEffect, useRef, useState } from "react";
import Icon from "../ui/Icon";

export default function ChatModal({
  open,
  onClose,
  canPublishData,
  nameByIdentity,
  chatMessages = [],
  onSend,
}) {
  const [text, setText] = useState("");
  const endRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [open, chatMessages.length]);

  if (!open) return null;

  return (
    <div
      className="jt-modalOverlay"
      role="dialog"
      aria-modal="true"
      onMouseDown={onClose}
    >
      <div
        className="jt-sheet jt-sheetChat"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="jt-sheetHead">
          <div className="jt-sheetTitle">
            <span className="jt-sheetIcon">
              <Icon name="chat" />
            </span>
            Chat
          </div>
          <button
            className="jt-sheetClose"
            onClick={onClose}
            aria-label="Close"
          >
            <Icon name="close" />
          </button>
        </div>

        <div className="jt-sheetBody jt-chatBody">
          <div className="jt-chatWrap">
            <div className="jt-chatMsgs">
              {chatMessages.map((m, idx) => {
                const identity = m.from?.identity || "";
                const displayName =
                  (identity && nameByIdentity?.[identity]) ||
                  m.from?.name ||
                  (() => {
                    const match = /^user_[a-f\d]{24}_(.+)$/i.exec(identity);
                    return match?.[1] || identity || "Unknown";
                  })() ||
                  "Unknown";

                return (
                  <div
                    key={`${identity}-${m.timestamp?.getTime?.() ?? idx}`}
                    className="jt-chatMsg"
                  >
                    <div className="jt-chatMsgName">{displayName}</div>
                    <div className="jt-chatMsgText">{m.message}</div>
                  </div>
                );
              })}
              <div ref={endRef} />
            </div>

            <form
              className="jt-chatInputRow"
              onSubmit={(e) => {
                e.preventDefault();
                if (!canPublishData) return;
                onSend?.(text);
                setText("");
              }}
            >
              <input
                className="jt-chatInput"
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder={
                  canPublishData
                    ? "Type a message..."
                    : "Chat disabled for this table"
                }
                disabled={!canPublishData}
              />
              <button
                className="jt-chatSendBtn"
                type="submit"
                disabled={!canPublishData || !text.trim()}
              >
                Send
              </button>
            </form>

            {!canPublishData && (
              <div className="jt-panelDisabled" style={{ marginTop: 10 }}>
                You don&apos;t have permission to use chat in this table.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
